
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8PbIb", function(module, exports) {

$parcel$export(module.exports, "calcolaPivaOrdinaria", () => $66cc2bd54d6eac72$export$5875fe6f1d2de8d8);
// Motore di calcolo puro per la partita IVA in regime ordinario (contabilita'
// semplificata / ordinaria, persona fisica). Nessuna dipendenza dal DOM: viene
// riusato sia dal controller di pagina (js/pivaOrdinaria.js) sia dai test
// (tests/pivaOrdinaria.test.js).
//
// A differenza del forfettario (coefficiente di redditivita' + imposta
// sostitutiva piatta), il regime ordinario tassa il reddito effettivo
// (ricavi - costi reali - contributi) con IRPEF progressiva a scaglioni piu'
// addizionali regionale e comunale. L'IVA e' neutra (incassata dai clienti e
// versata allo Stato) quindi tutti gli importi sono al netto IVA. L'IRAP non e'
// dovuta dalle persone fisiche dal 2022.
//
// Gli import sono relativi (non "/js/...") cosi' il modulo e' eseguibile anche
// sotto node --test, oltre che bundlato da Parcel per il browser.

var $3ItrY = parcelRequire("3ItrY");

var $eXCXK = parcelRequire("eXCXK");
function $66cc2bd54d6eac72$export$5b752fcb90d5c4bd(imponibile) {
    const reddito = Math.max(0, imponibile || 0);
    let detrazione = 0;
    if (reddito <= 5500) detrazione = reddito > 0 ? 1265 : 0;
    else if (reddito <= 28000) detrazione = 500 + 765 * ((28000 - reddito) / 22500);
    else if (reddito <= 50000) detrazione = 500 * ((50000 - reddito) / 22000);
    else detrazione = 0;
    // Maggiorazione di 50 EUR per redditi tra 11.000 e 17.000 EUR (c. 5-ter).
    if (reddito >= 11000 && reddito <= 17000) detrazione += 50;
    return Math.round(Math.max(0, detrazione));
}
function $66cc2bd54d6eac72$export$e486ec2c2ce34384(imposta) {
    const base = Math.max(0, Math.round(imposta || 0));
    if (base < 51.65) return {
        dovuto: false,
        modalita: 'nessuno',
        accontoTotale: 0,
        acconto1: 0,
        acconto2: 0
    };
    if (base <= 257.52) return {
        dovuto: true,
        modalita: 'unica',
        accontoTotale: base,
        acconto1: 0,
        acconto2: base
    };
    const acconto1 = Math.round(base * 0.40);
    const acconto2 = Math.round(base * 0.60);
    return {
        dovuto: true,
        modalita: 'rate',
        accontoTotale: acconto1 + acconto2,
        acconto1: acconto1,
        acconto2: acconto2
    };
}
function $66cc2bd54d6eac72$export$7b9767e76800b4c(base) {
    const b = Math.max(0, Math.round(base || 0));
    if (b <= 0) return {
        dovuto: false,
        accontoTotale: 0,
        rata1: 0,
        rata2: 0
    };
    const rata1 = Math.round(b * 0.40);
    const accontoTotale = Math.round(b * 0.80);
    const rata2 = Math.max(0, accontoTotale - rata1);
    return {
        dovuto: true,
        accontoTotale: accontoTotale,
        rata1: rata1,
        rata2: rata2
    };
}
function $66cc2bd54d6eac72$export$765ac2b3d1b6e141(ral, data, params = {}) {
    const lordo = Math.max(0, parseFloat(ral) || 0);
    if (lordo <= 0) return 0;
    const year = params.year || '2026';
    const aliquota = data?.aliquote_inps?.lavoratore?.regolare ?? 0.0919;
    const { inpsDipendente: inpsDipendente } = (0, $3ItrY.calculateInps)(lordo, data, {
        year: year,
        alinpsDip: aliquota * 100,
        alinpsDat: 0,
        mensilita: params.mensilita || 14
    });
    return Math.max(0, Math.round(lordo - inpsDipendente));
}
// Detrazione da lavoro spettante su un dato reddito complessivo.
// Art. 13 c. 5 TUIR: la detrazione per lavoro autonomo NON e' cumulabile con
// quella per lavoro dipendente (commi 1-4); chi ha entrambi i redditi fruisce
// della piu' favorevole, non della somma.
function $66cc2bd54d6eac72$var$detrazioneDaLavoro(redditoComplessivo, { conRedditoDipendente: conRedditoDipendente, conDetrazioneAutonomo: conDetrazioneAutonomo }) {
    const daDipendente = conRedditoDipendente ? (0, $3ItrY.calculateDetrazioniIrpef)(redditoComplessivo) : 0;
    const daAutonomo = conDetrazioneAutonomo ? $66cc2bd54d6eac72$export$5b752fcb90d5c4bd(redditoComplessivo) : 0;
    return Math.max(daDipendente, daAutonomo);
}
function $66cc2bd54d6eac72$export$5875fe6f1d2de8d8(input, data) {
    const year = input.year || '2026';
    const ricavi = Math.max(0, parseFloat(input.ricavi) || 0);
    const costi = Math.max(0, parseFloat(input.costiDeducibili) || 0);
    const comune = input.comune || {};
    // Reddito d'impresa/professionale prima dei contributi.
    const redditoLordo = Math.max(0, ricavi - costi);
    const imponibileContributi = redditoLordo;
    const previdenza = (0, $eXCXK.calcolaContributiPrevidenziali)(imponibileContributi, ricavi, input.gestione, {
        mesiAttivita: input.mesiAttivita,
        nuovaAttivitaArtCom: input.nuovaAttivitaArtCom,
        riduzione50: input.riduzione50,
        ante1996: input.ante1996,
        numeroMandanti: input.numeroMandanti,
        fasciaEtaEnpam: input.fasciaEtaEnpam,
        dipendenteFullTime: input.dipendenteFullTime,
        riduzioneDipendente: input.riduzioneDipendente
    });
    const { contributi: contributi, contributiDeducibili: contributiDeducibili, contributiAcconto: contributiAcconto, contributiFissi: contributiFissi, contributoIntegrativo: contributoIntegrativo, integrativoRivalsa: integrativoRivalsa, contributiACarico: contributiACarico } = previdenza;
    // Base imponibile IRPEF della P.IVA: reddito al netto dei contributi deducibili.
    const imponibileIrpef = Math.max(0, imponibileContributi - contributiDeducibili);
    // La detrazione art. 13 c. 5 TUIR copre i redditi di lavoro autonomo (art. 53)
    // e i redditi d'impresa "minori" (art. 66, contabilita' semplificata). Chi
    // opta per la contabilita' ordinaria non ne ha diritto.
    const conDetrazioneAutonomo = !input.contabilitaOrdinaria;
    // Se si e' gia' lavoratori dipendenti/pensionati, il reddito P.IVA si somma
    // al reddito complessivo: l'IRPEF sulla quota P.IVA e' la differenza tra
    // l'imposta netta sul complessivo e quella sul solo stipendio. Cosi' si
    // cattura non solo lo scaglione marginale ma anche l'erosione delle
    // detrazioni da lavoro dipendente, che e' la parte piu' pesante.
    const redditoDipendente = input.dipendenteFullTime ? $66cc2bd54d6eac72$export$765ac2b3d1b6e141(input.ralDipendente, data, {
        year: year
    }) : 0;
    const imponibileTotale = redditoDipendente + imponibileIrpef;
    const paramsReg = {
        regione: input.regione || '',
        year: year
    };
    const paramsCom = {
        esenzione: comune.esenzione,
        scaglioni: comune.scaglioni,
        addizionaleComunale: comune.aliquota
    };
    let irpefLorda;
    let detrazioni;
    let irpefNetta;
    let addizionaleRegionale;
    let addizionaleComunale;
    let sommaIntegrativaPersa = 0;
    if (redditoDipendente > 0) {
        // --- Imposta netta sul solo stipendio (situazione di partenza) --------
        const irpefLordaDip = (0, $3ItrY.calculateIrpef)(redditoDipendente, data, {
            year: year
        });
        const detrDipSolo = (0, $3ItrY.calculateDetrazioniIrpef)(redditoDipendente);
        const ulterioreDipSolo = (0, $3ItrY.calculateUlterioreDetrazione)(redditoDipendente, 0, {
            cuneoFiscale: true
        });
        const irpefNettaDip = Math.max(0, irpefLordaDip - detrDipSolo - ulterioreDipSolo);
        // --- Imposta netta sul reddito complessivo (stipendio + P.IVA) --------
        const irpefLordaTot = (0, $3ItrY.calculateIrpef)(imponibileTotale, data, {
            year: year
        });
        const detrLavoroTot = $66cc2bd54d6eac72$var$detrazioneDaLavoro(imponibileTotale, {
            conRedditoDipendente: true,
            conDetrazioneAutonomo: conDetrazioneAutonomo
        });
        const ulterioreTot = (0, $3ItrY.calculateUlterioreDetrazione)(imponibileTotale, 0, {
            cuneoFiscale: true
        });
        const irpefNettaTot = Math.max(0, irpefLordaTot - detrLavoroTot - ulterioreTot);
        // Quota IRPEF imputabile alla P.IVA.
        irpefLorda = Math.max(0, irpefLordaTot - irpefLordaDip);
        irpefNetta = Math.max(0, irpefNettaTot - irpefNettaDip);
        // Variazione delle detrazioni: negativa quando il reddito P.IVA erode le
        // detrazioni gia' godute sullo stipendio. Derivata dai due estremi cosi'
        // il dettaglio "lorda - detrazioni = netta" torna sempre.
        detrazioni = irpefLorda - irpefNetta;
        // Trattamento integrativo (art. 1 c. 4 L. 207/2024): spetta se il reddito
        // COMPLESSIVO non supera 20.000. Il reddito P.IVA puo' farlo perdere: non
        // e' un'imposta, quindi resta fuori da imposteTotali e viene esposto a parte.
        const sommaIntegrativaDip = (0, $3ItrY.calculateSommaIntegrativa)(redditoDipendente, {
            cuneoFiscale: true
        });
        const sommaIntegrativaTot = imponibileTotale <= 20000 ? sommaIntegrativaDip : 0;
        sommaIntegrativaPersa = Math.max(0, sommaIntegrativaDip - sommaIntegrativaTot);
        // Addizionali: differenza tra quelle sul complessivo e quelle sul solo
        // stipendio. Sono dovute se l'IRPEF netta e' dovuta, quindi il gate e'
        // l'imposta NETTA (non la lorda).
        addizionaleRegionale = Math.max(0, (0, $3ItrY.calculateAddizionaleRegionale)(imponibileTotale, data, irpefNettaTot, paramsReg) - (0, $3ItrY.calculateAddizionaleRegionale)(redditoDipendente, data, irpefNettaDip, paramsReg));
        addizionaleComunale = Math.max(0, (0, $3ItrY.calculateAddizionaleComunale)(imponibileTotale, irpefNettaTot, paramsCom) - (0, $3ItrY.calculateAddizionaleComunale)(redditoDipendente, irpefNettaDip, paramsCom));
    } else {
        // Solo reddito P.IVA: IRPEF dal primo scaglione.
        irpefLorda = (0, $3ItrY.calculateIrpef)(imponibileIrpef, data, {
            year: year
        });
        detrazioni = $66cc2bd54d6eac72$var$detrazioneDaLavoro(imponibileIrpef, {
            conRedditoDipendente: false,
            conDetrazioneAutonomo: conDetrazioneAutonomo
        });
        irpefNetta = Math.max(0, irpefLorda - detrazioni);
        addizionaleRegionale = (0, $3ItrY.calculateAddizionaleRegionale)(imponibileIrpef, data, irpefNetta, paramsReg);
        addizionaleComunale = (0, $3ItrY.calculateAddizionaleComunale)(imponibileIrpef, irpefNetta, paramsCom);
    }
    const imposteTotali = irpefNetta + addizionaleRegionale + addizionaleComunale;
    // Dal netto si sottraggono i contributi effettivamente a carico: la quota
    // integrativa ribaltata in fattura al cliente entra ed esce, non e' un costo.
    // Il netto puo' essere negativo (perdita reale quando costi + contributi
    // superano i ricavi): si mostra la perdita, non si clampa a zero.
    const nettoAnnuo = Math.round(ricavi - costi - contributiACarico - imposteTotali);
    const nettoMensile = Math.round(nettoAnnuo / 12);
    // Acconti col metodo storico, distinti per tributo:
    //  - IRPEF: 100% (40% giugno + 60% novembre);
    //  - INPS: 80% (40% + 40%) sulla quota soggetta ad acconto;
    //  - addizionale comunale: 30% (regionale: nessun acconto).
    const accontoIrpef = $66cc2bd54d6eac72$export$e486ec2c2ce34384(irpefNetta);
    const accontoInps = $66cc2bd54d6eac72$export$7b9767e76800b4c(contributiAcconto);
    const accontoComunale = accontoIrpef.dovuto ? Math.round(addizionaleComunale * 0.30) : 0;
    const acconti = {
        irpef: accontoIrpef,
        inps: accontoInps,
        comunale: accontoComunale
    };
    return {
        ricavi: ricavi,
        costi: costi,
        redditoLordo: redditoLordo,
        imponibileContributi: imponibileContributi,
        contributi: Math.round(contributi),
        contributiDeducibili: Math.round(contributiDeducibili),
        contributoIntegrativo: Math.round(contributoIntegrativo),
        integrativoRivalsa: Math.round(integrativoRivalsa),
        contributiACarico: Math.round(contributiACarico),
        contributiAcconto: Math.round(contributiAcconto),
        contributiFissi: Math.round(contributiFissi),
        imponibilePrevidenziale: Math.round(previdenza.imponibilePrevidenziale),
        massimaleContributivo: previdenza.massimale,
        massimaleApplicato: previdenza.massimaleApplicato,
        redditoDipendente: Math.round(redditoDipendente),
        imponibileTotale: Math.round(imponibileTotale),
        imponibileIrpef: Math.round(imponibileIrpef),
        irpefLorda: irpefLorda,
        detrazioni: // `detrazioni` e' la detrazione spettante nel caso standalone e la
        // VARIAZIONE di detrazioni (tipicamente negativa) nel caso misto.
        detrazioni,
        detrazioneLavoroAutonomo: detrazioni,
        sommaIntegrativaPersa: sommaIntegrativaPersa,
        irpefNetta: irpefNetta,
        addizionaleRegionale: addizionaleRegionale,
        addizionaleComunale: addizionaleComunale,
        imposteTotali: Math.round(imposteTotali),
        nettoAnnuo: nettoAnnuo,
        nettoMensile: nettoMensile,
        acconti: acconti
    };
}

});
parcelRegister("eXCXK", function(module, exports) {

$parcel$export(module.exports, "calcolaContributiPrevidenziali", () => $ae44cc8907afb7c1$export$267d35975a92ee28);
// Calcolo dei contributi previdenziali per titolari di partita IVA.
//
// La logica di base e' quella usata dal calcolatore forfettario
// (js/forfettario.js), qui estratta in una funzione pura e riutilizzabile: il
// regime forfettario e quello ordinario calcolano i contributi allo stesso
// modo, cambia solo la base imponibile previdenziale (forfettario: fatturato x
// coefficiente; ordinario: ricavi - costi).
//
// Rispetto al forfettario e' modellato anche il MASSIMALE contributivo: nel
// forfettario e' irrilevante (85.000 x 78% = 66.300, sempre sotto il tetto),
// nell'ordinario no, ed e' proprio la fascia di reddito che usa questo regime.
//
// gestione = un elemento di data/forfettario.json -> gestioni_previdenziali.
//
// Ritorna:
//   - contributi:            totale versato all'ente previdenziale.
//   - contributiDeducibili:  quota deducibile dal reddito imponibile IRPEF.
//     Coincide con `contributi` tranne per l'integrativo delle casse che,
//     essendo addebitato in rivalsa al cliente, non e' un costo del
//     professionista e quindi non e' deducibile.
//   - contributoIntegrativo: quota integrativa dovuta alla cassa.
//   - integrativoRivalsa:    parte dell'integrativo effettivamente recuperata
//     dal cliente in fattura. Coincide con l'integrativo salvo quando scatta il
//     minimo: la differenza tra minimo e percentuale sul volume d'affari resta
//     a carico del professionista.
//   - contributiACarico:     quanto esce davvero di tasca (contributi meno la
//     parte di integrativo ribaltata sul cliente). E' questo, non `contributi`,
//     a ridurre il netto.
//   - imponibilePrevidenziale: base effettivamente assoggettata a contribuzione
//     (cioe' il reddito eventualmente tagliato dal massimale).
//   - massimaleApplicato: true se il massimale ha morso.
const $ae44cc8907afb7c1$var$clampInt = (value, min, max, fallback)=>{
    const n = parseInt(value, 10);
    if (!Number.isInteger(n)) return fallback;
    return Math.min(Math.max(n, min), max);
};
function $ae44cc8907afb7c1$export$97981c34ea55c837(gestione, params = {}) {
    if (!gestione) return Infinity;
    const ante1996 = Boolean(params.ante1996);
    if (ante1996 && gestione.massimale_reddito_ante1996 != null) return gestione.massimale_reddito_ante1996;
    return gestione.massimale_reddito ?? Infinity;
}
function $ae44cc8907afb7c1$export$267d35975a92ee28(imponibileContributi, baseRivalsa, gestione, params = {}) {
    const mesiAttivita = $ae44cc8907afb7c1$var$clampInt(params.mesiAttivita ?? 12, 1, 12, 12);
    const numeroMandanti = $ae44cc8907afb7c1$var$clampInt(params.numeroMandanti ?? 1, 1, 50, 1);
    const nuovaAttivitaArtCom = Boolean(params.nuovaAttivitaArtCom);
    const riduzione50Richiesta = Boolean(params.riduzione50);
    // Riduzione 35% riservata ai forfettari iscritti ad Artigiani/Commercianti
    // (L. 190/2014 art. 1 c. 77). Non esiste in regime ordinario: il motore
    // ordinario semplicemente non passa questo parametro.
    const riduzione35Richiesta = Boolean(params.riduzione35);
    const dipendenteFullTime = Boolean(params.dipendenteFullTime);
    const riduzioneDipendente = Boolean(params.riduzioneDipendente);
    // Nel regime ordinario non esiste il tetto di reddito da lavoro dipendente
    // (35.000 EUR) previsto per l'accesso al forfettario: la riduzione
    // contributiva del dipendente gia' assicurato altrove si applica sempre.
    const riduzioneDipendenteAttiva = riduzioneDipendente && dipendenteFullTime;
    // Massimale: oltre questa soglia il reddito non e' piu' assoggettato.
    const massimale = $ae44cc8907afb7c1$export$97981c34ea55c837(gestione, params);
    const imponibile = Math.min(Math.max(0, imponibileContributi), massimale);
    const massimaleApplicato = Number.isFinite(massimale) && imponibileContributi > massimale;
    let contributi = 0;
    let contributiDeducibili = null;
    let contributoIntegrativo = 0;
    let integrativoRivalsa = 0;
    let minimaleFisso = 0; // parte in rate fisse (minimale art/com), esclusa dall'acconto
    if (gestione?.tipo === 'CASSA_CON_MINIMI') {
        // Casse professionali: soggettivo (con minimo, e spesso con aliquota
        // ridotta oltre un limite reddituale) + integrativo sul volume d'affari
        // + eventuale supplementare, solidarieta' e maternita'.
        const limite = gestione.limite_reddito_soggettivo ?? Infinity;
        const aliquotaOltre = gestione.aliquota_soggettivo_oltre ?? 0;
        const soggettivoCalcolato = Math.min(imponibile, limite) * ((gestione.aliquota_soggettivo ?? 0) / 100) + Math.max(0, imponibile - limite) * (aliquotaOltre / 100);
        const contributoSoggettivo = Math.max(soggettivoCalcolato, gestione.minimo_soggettivo ?? 0);
        // Alcune casse (es. CNPR) affiancano un soggettivo supplementare.
        const aliquotaSuppl = gestione.aliquota_soggettivo_supplementare ?? 0;
        const minimoSuppl = gestione.minimo_soggettivo_supplementare ?? 0;
        const contributoSupplementare = aliquotaSuppl > 0 || minimoSuppl > 0 ? Math.max(imponibile * (aliquotaSuppl / 100), minimoSuppl) : 0;
        // Integrativo: percentuale sul volume d'affari, con un minimo. La parte
        // "a percentuale" viene ribaltata in fattura al cliente; l'eventuale
        // scarto fino al minimo resta a carico del professionista.
        const aliquotaIntegrativo = gestione.aliquota_integrativo ?? 0;
        const integrativoPercentuale = baseRivalsa * (aliquotaIntegrativo / 100);
        contributoIntegrativo = Math.max(integrativoPercentuale, gestione.minimo_integrativo ?? 0);
        integrativoRivalsa = Math.min(contributoIntegrativo, integrativoPercentuale);
        const aliquotaSolid = gestione.aliquota_solidarieta ?? 0;
        const minimoSolid = gestione.minimo_solidarieta ?? 0;
        const contributoSolidarieta = aliquotaSolid > 0 || minimoSolid > 0 ? Math.max(imponibile * (aliquotaSolid / 100), minimoSolid) : 0;
        const contributoMaternita = gestione.contributo_maternita ?? 0;
        contributi = contributoSoggettivo + contributoSupplementare + contributoIntegrativo + contributoSolidarieta + contributoMaternita;
        contributiDeducibili = contributoSoggettivo + contributoSupplementare + contributoSolidarieta + contributoMaternita;
    } else if (gestione?.tipo === 'ENPAM') {
        // ENPAM: Quota A fissa per fascia d'eta' (copre gia' una quota di
        // reddito) + Quota B percentuale sul solo reddito eccedente.
        const fasce = gestione.quota_a || {};
        const fascia = fasce[params.fasciaEtaEnpam] != null ? params.fasciaEtaEnpam : 'over40';
        const quotaA = fasce[fascia] ?? 0;
        const franchigie = gestione.franchigia_quota_b || {};
        const franchigia = fascia === 'over40' ? franchigie.over40 ?? 0 : franchigie.under40 ?? 0;
        const baseQuotaB = Math.max(0, imponibile - franchigia);
        const limiteB = gestione.limite_quota_b ?? Infinity;
        const quotaB = Math.min(baseQuotaB, limiteB) * ((gestione.aliquota_quota_b ?? 0) / 100) + Math.max(0, baseQuotaB - limiteB) * ((gestione.aliquota_quota_b_oltre ?? 0) / 100);
        // ENPAM non ha contributo integrativo: tutto e' deducibile.
        contributi = quotaA + quotaB + (gestione.contributo_maternita ?? 0);
    } else if (gestione?.tipo === 'MISTO_CON_MINIMALE') {
        const proRataFactor = mesiAttivita / 12;
        const minimale = (gestione.minimale_reddito || 0) * proRataFactor;
        const fisso = (gestione.costo_fisso_annuo || 0) * proRataFactor;
        minimaleFisso = fisso;
        const eccedenza = Math.max(imponibile - minimale, 0);
        const contributiBase = fisso + eccedenza * ((gestione.aliquota_eccedenza || 0) / 100);
        let contributoSolidarieta = 0;
        const sogliaSolidarieta = gestione.soglia_solidarieta || 0;
        if (sogliaSolidarieta > 0 && imponibile > sogliaSolidarieta) contributoSolidarieta = (imponibile - sogliaSolidarieta) * 0.01;
        contributi = contributiBase + contributoSolidarieta;
    } else if (gestione?.tipo === 'ENASARCO') {
        // Massimale e minimale ENASARCO si applicano per rapporto di agenzia:
        // il plurimandatario li moltiplica per il numero di mandanti.
        const aliquotaAgente = (gestione.aliquota_agente || 0) / 100;
        const perMandante = Boolean(gestione.mandanti_multipli);
        const mandanti = perMandante ? numeroMandanti : 1;
        const massimaleUnitario = perMandante ? gestione.massimale_provvigioni_per_mandante ?? Infinity : gestione.massimale_provvigioni ?? Infinity;
        const massimaleProvvigioni = massimaleUnitario * mandanti;
        const minimaleAgente = (gestione.minimale_annuo_agente || 0) * mandanti;
        const baseCalcolo = Math.min(baseRivalsa, massimaleProvvigioni);
        const contributoCalcolato = baseCalcolo * aliquotaAgente;
        contributi = Math.max(contributoCalcolato, minimaleAgente);
    } else {
        // PERCENTUALE_PURA (INPS Gestione Separata, casse professionali "pure").
        let aliquotaContributiva = gestione ? gestione.aliquota || 0 : 0;
        if (riduzioneDipendenteAttiva && gestione?.id === 'INPS_GS') aliquotaContributiva = 24.0;
        contributi = imponibile * (aliquotaContributiva / 100);
    }
    // Dipendente full-time gia' assicurato: esenzione dai contributi minimi
    // Artigiani/Commercianti (si versa solo sull'eccedenza, qui azzerata perche'
    // il minimale non e' dovuto).
    if (riduzioneDipendenteAttiva && [
        'INPS_ART',
        'INPS_COM'
    ].includes(gestione?.id || '')) {
        contributi = 0;
        minimaleFisso = 0;
    }
    // Riduzione 50% per nuove iscrizioni Artigiani/Commercianti (art. 1 c. 186
    // L. 207/2024): riservata a chi si e' iscritto per la prima volta nel 2025,
    // per 36 mesi. NON e' stata prorogata per le iscrizioni dal 2026. La
    // riduzione 35% del forfettario non e' disponibile in regime ordinario.
    if (!riduzioneDipendenteAttiva && [
        'INPS_ART',
        'INPS_COM'
    ].includes(gestione?.id || '')) {
        // Le due riduzioni non sono cumulabili: la 50% prevale se richiesta.
        if (riduzione50Richiesta && nuovaAttivitaArtCom) {
            contributi = contributi * 0.50;
            minimaleFisso = minimaleFisso * 0.50;
        } else if (riduzione35Richiesta && gestione?.riduzione_forfettario_disponibile) {
            contributi = contributi * 0.65;
            minimaleFisso = minimaleFisso * 0.65;
        }
    }
    // Parte dei contributi soggetta a saldo + acconto (come l'IRPEF) vs parte in
    // rate fisse. Gestione Separata: tutto ad acconto. Artigiani/Commercianti:
    // solo l'eccedenza sopra il minimale (il fisso e' in 4 rate fisse). Casse
    // professionali/ENASARCO: acconti con regole proprie, non modellati.
    const id = gestione?.id || '';
    let contributiFissi = 0;
    let contributiAcconto = 0;
    if (id === 'INPS_GS') contributiAcconto = contributi;
    else if ([
        'INPS_ART',
        'INPS_COM'
    ].includes(id)) {
        contributiFissi = minimaleFisso;
        contributiAcconto = Math.max(0, contributi - minimaleFisso);
    }
    return {
        contributi: contributi,
        contributiDeducibili: contributiDeducibili ?? contributi,
        contributoIntegrativo: contributoIntegrativo,
        integrativoRivalsa: integrativoRivalsa,
        contributiACarico: Math.max(0, contributi - integrativoRivalsa),
        contributiAcconto: contributiAcconto,
        contributiFissi: contributiFissi,
        imponibilePrevidenziale: imponibile,
        massimale: massimale,
        massimaleApplicato: massimaleApplicato
    };
}

});


parcelRegister("6tXh2", function(module, exports) {

$parcel$export(module.exports, "coefficienteDefault", () => $4b836e09c35541ed$export$312c760a41fcfdfb);
$parcel$export(module.exports, "costiImpliciti", () => $4b836e09c35541ed$export$7af6600a7dc73437);
$parcel$export(module.exports, "confrontaRegimi", () => $4b836e09c35541ed$export$86366098cecb4e69);
// Confronto tra regime forfettario e regime ordinario a parita' di attivita'.
//
// Serve entrambe le pagine: il calcolatore ordinario mostra "quanto avresti nel
// forfettario" (solo se i requisiti ci sono), quello forfettario mostra "quanto
// avresti nell'ordinario" — informazione decisiva quando il fatturato supera la
// soglia degli 85.000 EUR e il forfettario non e' piu' una scelta possibile.
//
// Modulo puro: nessun DOM, cosi' e' testabile e condivisibile.

var $8PbIb = parcelRequire("8PbIb");

var $hEAJx = parcelRequire("hEAJx");
const $4b836e09c35541ed$export$fce4d3321b6f77e9 = [
    {
        valore: 40,
        label: 'Commercio, alimentari e bevande, ambulanti (40%)'
    },
    {
        valore: 54,
        label: 'Ambulanti di altri prodotti (54%)'
    },
    {
        valore: 62,
        label: 'Intermediari del commercio (62%)'
    },
    {
        valore: 67,
        label: "Costruzioni, artigianato e attivit\xe0 immobiliari (67%)"
    },
    {
        valore: 78,
        label: "Professionisti e attivit\xe0 scientifiche (78%)"
    },
    {
        valore: 86,
        label: "Altre attivit\xe0 economiche (86%)"
    }
];
function $4b836e09c35541ed$export$312c760a41fcfdfb(formaAttivita) {
    switch(formaAttivita){
        case 'ditta_commerciale':
            return 40;
        case 'ditta_artigiana':
            return 67;
        case 'libero_senza_cassa':
        case 'libero_con_cassa':
            return 78;
        default:
            return 78;
    }
}
function $4b836e09c35541ed$export$c636dd1c309a1c6c(input = {}) {
    const ricavi = Math.max(0, parseFloat(input.ricavi) || 0);
    const ralDipendente = parseFloat(input.ralDipendente) || 0;
    const haRedditoDipendente = Boolean(input.dipendenteFullTime) && ralDipendente > 0;
    if (ricavi > (0, $hEAJx.SOGLIA_USCITA_IMMEDIATA)) return {
        ammissibile: false,
        causa: 'ricavi_oltre_100k',
        motivo: `Con ricavi oltre ${(0, $hEAJx.SOGLIA_USCITA_IMMEDIATA).toLocaleString('it-IT')} \u{20AC} il forfettario decade subito, gi\xe0 dall'anno in corso.`
    };
    if (ricavi > (0, $hEAJx.SOGLIA_FORFETTARIO)) return {
        ammissibile: false,
        causa: 'ricavi_oltre_soglia',
        motivo: `Il forfettario si pu\xf2 usare fino a ${(0, $hEAJx.SOGLIA_FORFETTARIO).toLocaleString('it-IT')} \u{20AC} di ricavi o compensi: sopra questa soglia si passa all'ordinario dall'anno successivo.`
    };
    if (haRedditoDipendente && !(0, $hEAJx.redditoDipendenteAmmesso)(ralDipendente)) return {
        ammissibile: false,
        causa: 'reddito_dipendente',
        motivo: `Con pi\xf9 di ${(0, $hEAJx.TETTO_REDDITO_DIPENDENTE).toLocaleString('it-IT')} \u{20AC} di reddito da lavoro dipendente o pensione non si pu\xf2 accedere al forfettario.`
    };
    return {
        ammissibile: true,
        causa: null,
        motivo: ''
    };
}
function $4b836e09c35541ed$export$7af6600a7dc73437(fatturato, coefficienteRedditivita) {
    const f = Math.max(0, parseFloat(fatturato) || 0);
    const c = Math.min(Math.max(parseFloat(coefficienteRedditivita) || 0, 0), 100);
    return Math.round(f * (1 - c / 100));
}
function $4b836e09c35541ed$export$86366098cecb4e69(input, data) {
    const ricavi = Math.max(0, parseFloat(input.ricavi) || 0);
    // Sopra la soglia un forfettario "a parita' di fatturato" non esiste: i suoi
    // numeri sarebbero pura invenzione. L'unica domanda sensata diventa "e se
    // limitassi il fatturato a 85.000 € per restare nel regime agevolato?": il
    // forfettario si calcola quindi sul massimo consentito.
    const fatturatoForfettario = Math.min(ricavi, (0, $hEAJx.SOGLIA_FORFETTARIO));
    const forfettarioLimitato = fatturatoForfettario < ricavi;
    const ordinario = (0, $8PbIb.calcolaPivaOrdinaria)({
        ricavi: input.ricavi,
        costiDeducibili: input.costiDeducibili,
        gestione: input.gestione,
        mesiAttivita: input.mesiAttivita,
        nuovaAttivitaArtCom: input.nuovaAttivitaArtCom,
        riduzione50: input.riduzione50,
        ante1996: input.ante1996,
        numeroMandanti: input.numeroMandanti,
        fasciaEtaEnpam: input.fasciaEtaEnpam,
        contabilitaOrdinaria: input.contabilitaOrdinaria,
        dipendenteFullTime: input.dipendenteFullTime,
        riduzioneDipendente: input.riduzioneDipendente,
        ralDipendente: input.ralDipendente,
        regione: input.regione,
        comune: input.comune,
        year: input.year
    }, data);
    const forfettario = (0, $hEAJx.calcolaForfettario)({
        fatturato: fatturatoForfettario,
        coefficienteRedditivita: input.coefficienteRedditivita,
        aliquotaImposta: input.aliquotaImposta,
        gestione: input.gestione,
        mesiAttivita: input.mesiAttivita,
        nuovaAttivitaArtCom: input.nuovaAttivitaArtCom,
        riduzione50: input.riduzione50,
        riduzione35: input.riduzione35,
        numeroMandanti: input.numeroMandanti,
        fasciaEtaEnpam: input.fasciaEtaEnpam,
        dipendenteFullTime: input.dipendenteFullTime,
        riduzioneDipendente: input.riduzioneDipendente,
        ralDipendente: input.ralDipendente
    });
    const ammissibilita = $4b836e09c35541ed$export$c636dd1c309a1c6c(input);
    // Ogni regime mostra il SUO netto, come lo calcolano le rispettive pagine:
    // l'ordinario deduce i costi reali, il forfettario li ignora e non li
    // sottrae. E' la stessa cifra che l'utente ritrova aprendo i due
    // calcolatori, e la nota sotto la card ricorda che nel forfettario i costi
    // restano comunque a carico.
    const costiReali = Math.max(0, parseFloat(input.costiDeducibili) || 0);
    const nettoOrdinario = ordinario.nettoAnnuo;
    const nettoForfettario = forfettario.nettoAnnuo;
    const differenza = nettoForfettario - nettoOrdinario;
    return {
        ordinario: ordinario,
        forfettario: forfettario,
        ammissibilita: ammissibilita,
        costiReali: costiReali,
        fatturatoForfettario: // Fatturato su cui e' calcolato il forfettario: coincide con i ricavi
        // sotto la soglia, altrimenti e' lo scenario "limitato a 85.000 €".
        fatturatoForfettario,
        forfettarioLimitato: forfettarioLimitato,
        nettoOrdinario: nettoOrdinario,
        nettoForfettario: nettoForfettario,
        // `migliore` descrive solo la convenienza economica: se il forfettario
        // non e' accessibile la scelta non esiste, e va letto insieme ad
        // ammissibilita.ammissibile.
        migliore: differenza === 0 ? 'pari' : differenza > 0 ? 'forfettario' : 'ordinario',
        differenza: differenza,
        differenzaAssoluta: Math.abs(differenza),
        differenzaMensile: Math.round(Math.abs(differenza) / 12)
    };
}

});
parcelRegister("hEAJx", function(module, exports) {

$parcel$export(module.exports, "SOGLIA_FORFETTARIO", () => $cda2aa9e39b6963b$export$12ec11571dce5ad8);
$parcel$export(module.exports, "SOGLIA_USCITA_IMMEDIATA", () => $cda2aa9e39b6963b$export$b31458bd849e5017);
$parcel$export(module.exports, "TETTO_REDDITO_DIPENDENTE", () => $cda2aa9e39b6963b$export$27e11540eea5bdf);
$parcel$export(module.exports, "redditoDipendenteAmmesso", () => $cda2aa9e39b6963b$export$3109ec1b86268eaa);
$parcel$export(module.exports, "calcolaForfettario", () => $cda2aa9e39b6963b$export$2aabdfbb4e6c759f);
// Motore di calcolo puro per la partita IVA in regime forfettario.
//
// Estratto da js/forfettario.js (che ne era l'unica sede, mescolato al DOM) per
// due motivi: poterlo testare senza browser e poterlo riusare nel confronto tra
// regimi (js/confrontoRegimi.js), che deve mostrare gli stessi numeri della
// pagina forfettario.
//
// Nel forfettario il reddito non si determina sui costi reali: si applica al
// fatturato il coefficiente di redditivita' dell'ATECO. Sul reddito, al netto
// dei contributi deducibili, si paga un'imposta sostitutiva piatta (5% per i
// primi 5 anni se ricorrono i requisiti di nuova attivita', altrimenti 15%),
// che sostituisce IRPEF e addizionali. Niente IVA in fattura, niente IRAP.

var $eXCXK = parcelRequire("eXCXK");
const $cda2aa9e39b6963b$export$12ec11571dce5ad8 = 85000;
const $cda2aa9e39b6963b$export$b31458bd849e5017 = 100000;
const $cda2aa9e39b6963b$export$27e11540eea5bdf = 35000;
function $cda2aa9e39b6963b$export$3109ec1b86268eaa(ralDipendente) {
    const ral = parseFloat(ralDipendente);
    if (!Number.isFinite(ral)) return true;
    return ral * 0.909 <= $cda2aa9e39b6963b$export$27e11540eea5bdf;
}
function $cda2aa9e39b6963b$export$2aabdfbb4e6c759f(input) {
    const fatturato = Math.max(0, parseFloat(input.fatturato) || 0);
    const coefficiente = Math.max(0, parseFloat(input.coefficienteRedditivita) || 0);
    const aliquotaImposta = Math.max(0, parseFloat(input.aliquotaImposta) || 0);
    // Base imponibile previdenziale e fiscale: fatturato x coefficiente.
    const imponibileContributi = fatturato * (coefficiente / 100);
    // Il tetto dei 35.000 EUR e' un requisito di ACCESSO al forfettario (art. 1
    // c. 57 lett. d-ter L. 190/2014), non una regola contributiva: la riduzione
    // da soggetto gia' assicurato dipende solo dall'essere dipendente full-time
    // altrove, esattamente come nel regime ordinario (vedi js/previdenza.js).
    // Tenerli separati serve al confronto tra regimi, che simula il forfettario
    // anche per chi non puo' usarlo: legandoli, a quella simulazione veniva
    // addebitato un minimale Artigiani/Commercianti che quella persona non
    // pagherebbe mai, con netti negativi privi di senso.
    const dipendenteAmmesso = $cda2aa9e39b6963b$export$3109ec1b86268eaa(input.ralDipendente);
    const previdenza = (0, $eXCXK.calcolaContributiPrevidenziali)(imponibileContributi, fatturato, input.gestione, {
        mesiAttivita: input.mesiAttivita,
        nuovaAttivitaArtCom: input.nuovaAttivitaArtCom,
        riduzione50: input.riduzione50,
        riduzione35: input.riduzione35,
        numeroMandanti: input.numeroMandanti,
        fasciaEtaEnpam: input.fasciaEtaEnpam,
        dipendenteFullTime: input.dipendenteFullTime,
        riduzioneDipendente: Boolean(input.riduzioneDipendente)
    });
    const { contributi: contributi, contributiDeducibili: contributiDeducibili, contributoIntegrativo: contributoIntegrativo, integrativoRivalsa: integrativoRivalsa, contributiACarico: contributiACarico } = previdenza;
    const imponibileImposta = Math.max(0, imponibileContributi - contributiDeducibili);
    const imposta = Math.max(0, Math.round(imponibileImposta * (aliquotaImposta / 100)));
    // Come nell'ordinario, l'integrativo di cassa e' ribaltato in fattura al
    // cliente: non riduce il netto.
    const nettoAnnuo = Math.round(fatturato - contributiACarico - imposta);
    return {
        fatturato: fatturato,
        coefficienteRedditivita: coefficiente,
        aliquotaImposta: aliquotaImposta,
        imponibileContributi: Math.round(imponibileContributi),
        contributi: Math.round(contributi),
        contributiDeducibili: Math.round(contributiDeducibili),
        contributoIntegrativo: Math.round(contributoIntegrativo),
        integrativoRivalsa: Math.round(integrativoRivalsa),
        contributiACarico: Math.round(contributiACarico),
        imponibileImposta: Math.round(imponibileImposta),
        imposta: imposta,
        // Nel forfettario l'imposta sostitutiva e' l'unico tributo: niente
        // addizionali. Il campo tiene la stessa forma del risultato ordinario.
        imposteTotali: imposta,
        nettoAnnuo: nettoAnnuo,
        nettoMensile: Math.round(nettoAnnuo / 12),
        dipendenteAmmesso: dipendenteAmmesso
    };
}

});


parcelRegister("1weAl", function(module, exports) {

$parcel$export(module.exports, "linkAllOrdinario", () => $11b417f0dcf3b99c$export$1a85b1fb8614ffe4);
$parcel$export(module.exports, "linkAlForfettario", () => $11b417f0dcf3b99c$export$2582d418c86fe3fb);
$parcel$export(module.exports, "renderConfronto", () => $11b417f0dcf3b99c$export$89acae1965627a0b);
// Rendering condiviso della card "confronto tra regimi", usata sia dalla pagina
// dei risultati ordinari sia da quella forfettaria. Le due pagine hanno lo
// stesso markup (stessi id), quindi la logica di riempimento e' una sola.
parcelRequire("6tXh2");
var $hEAJx = parcelRequire("hEAJx");
const $11b417f0dcf3b99c$export$676a761f30b5139c = (value)=>`${new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: 'always'
    }).format(value)} \u{20AC}`;
const $11b417f0dcf3b99c$var$encode = (obj)=>{
    try {
        return btoa(encodeURIComponent(JSON.stringify(obj)));
    } catch (e) {
        console.error('encode confronto failed', e);
        return null;
    }
};
const $11b417f0dcf3b99c$var$setText = (id, value)=>{
    const el = document.getElementById(id);
    if (el) el.textContent = value;
};
const $11b417f0dcf3b99c$var$setHtml = (id, value)=>{
    const el = document.getElementById(id);
    if (el) el.innerHTML = value;
};
function $11b417f0dcf3b99c$export$1a85b1fb8614ffe4(p) {
    const payload = {
        ricavi: Math.round(p.ricavi || 0),
        costi: Math.round(p.costi || 0),
        formaAttivita: p.formaAttivita || '',
        cassa: p.cassa || '',
        regione: p.regione || '',
        comune: p.comune || {
            aliquota: 0.8
        },
        dipendenteFullTime: Boolean(p.dipendenteFullTime),
        riduzioneDipendente: Boolean(p.riduzioneDipendente),
        ralDipendente: Math.round(p.ralDipendente || 0),
        mesiAttivita: p.mesiAttivita || 12,
        nuovaAttivitaArtCom: Boolean(p.nuovaAttivitaArtCom),
        riduzione50: Boolean(p.riduzione50),
        ante1996: Boolean(p.ante1996),
        numeroMandanti: p.numeroMandanti || 1,
        fasciaEtaEnpam: p.fasciaEtaEnpam || 'over40',
        contabilitaOrdinaria: Boolean(p.contabilitaOrdinaria)
    };
    const d = $11b417f0dcf3b99c$var$encode(payload);
    return d ? `/piva-ordinaria?d=${encodeURIComponent(d)}` : '/piva-ordinaria';
}
function $11b417f0dcf3b99c$export$2582d418c86fe3fb(p) {
    const payload = {
        fatturato: String(Math.round(p.ricavi || 0)),
        anniAttivita: String(p.aliquotaImposta || 15),
        tipoAttivita: String(p.coefficienteRedditivita || 78),
        formaAttivita: p.formaAttivita || '',
        cassa: p.cassa || '',
        mesiAttivita: String(p.mesiAttivita || 12),
        nuovaAttivitaArtCom: p.nuovaAttivitaArtCom ? '1' : '0',
        riduzione50: p.riduzione50 ? '1' : '0',
        riduzione35: p.riduzione35 ? '1' : '0',
        dipendenteFullTime: p.dipendenteFullTime ? '1' : '0',
        ralDipendente: String(Math.round(p.ralDipendente || 0)),
        riduzioneDipendente: p.riduzioneDipendente ? '1' : '0'
    };
    const d = $11b417f0dcf3b99c$var$encode(payload);
    return d ? `/piva-forfettario?d=${encodeURIComponent(d)}` : '/piva-forfettario';
}
function $11b417f0dcf3b99c$export$89acae1965627a0b(esito, opts = {}) {
    const wrapper = document.getElementById('confrontoRegimi');
    if (!wrapper) return;
    const daOrdinario = opts.origine === 'ordinario';
    const { ammissibilita: ammissibilita, migliore: migliore } = esito;
    const accessibile = ammissibilita.ammissibile;
    // Sopra la soglia il motore calcola il forfettario su 85.000 €, non sui
    // ricavi reali: tutta la copy deve dire che e' lo scenario "se limitassi
    // il fatturato", non un confronto a parita' di numeri.
    const limitato = Boolean(esito.forfettarioLimitato);
    const fatturatoLimite = $11b417f0dcf3b99c$export$676a761f30b5139c(esito.fatturatoForfettario || 0);
    wrapper.style.display = 'block';
    $11b417f0dcf3b99c$var$setText('confrontoTitolo', daOrdinario ? limitato ? 'E se limitassi il fatturato per il forfettario?' : 'Ti conviene il forfettario?' : 'E se passassi al regime ordinario?');
    // --- Colonne ------------------------------------------------------------
    $11b417f0dcf3b99c$var$setText('confrontoNettoOrdinario', $11b417f0dcf3b99c$export$676a761f30b5139c(esito.nettoOrdinario));
    $11b417f0dcf3b99c$var$setText('confrontoNettoForfettario', $11b417f0dcf3b99c$export$676a761f30b5139c(esito.nettoForfettario));
    $11b417f0dcf3b99c$var$setText('confrontoSubOrdinario', `${$11b417f0dcf3b99c$export$676a761f30b5139c(Math.round(esito.nettoOrdinario / 12))} al mese`);
    $11b417f0dcf3b99c$var$setText('confrontoSubForfettario', `${$11b417f0dcf3b99c$export$676a761f30b5139c(Math.round(esito.nettoForfettario / 12))} al mese`);
    const colOrd = document.getElementById('confrontoColOrdinario');
    const colFor = document.getElementById('confrontoColForfettario');
    const labelFor = colFor?.querySelector('.piva-vs-label');
    if (labelFor) labelFor.textContent = limitato ? `Forfettario a ${fatturatoLimite}` : 'Regime forfettario';
    colOrd?.classList.toggle('is-winner', accessibile && migliore === 'ordinario');
    colFor?.classList.toggle('is-winner', accessibile && migliore === 'forfettario');
    // Se il forfettario non e' accessibile la colonna resta, ma smorzata: serve
    // a quantificare cosa si perde, non a suggerire una scelta che non c'e'.
    colFor?.classList.toggle('is-unavailable', !accessibile);
    // --- Verdetto -----------------------------------------------------------
    const icona = document.getElementById('confrontoVerdettoIcona');
    const setIcona = (nome)=>{
        if (icona) icona.className = `ph ${nome}`;
    };
    if (!accessibile && limitato) {
        // Fatturato oltre la soglia: un forfettario a parita' di ricavi non
        // esiste, quindi il confronto risponde all'unica domanda reale, cioe'
        // "mi converrebbe limitare il fatturato a 85.000 € per restarci?".
        const netto = `<strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.nettoOrdinario)}</strong>`;
        const nettoFor = `<strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.nettoForfettario)}</strong>`;
        let ipotesi;
        if (migliore === 'pari') ipotesi = ` Nell'ordinario il netto \xe8 ${netto}. Se limitassi il fatturato a ${fatturatoLimite} per rientrare nel forfettario avresti lo stesso netto, pur fatturando meno.`;
        else if (migliore === 'forfettario') ipotesi = ` Nell'ordinario il netto \xe8 ${netto}. Se limitassi il fatturato a ${fatturatoLimite} per rientrare nel forfettario ti resterebbero ${nettoFor}: <strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.differenzaAssoluta)}</strong> in pi\xf9 all'anno, pur fatturando meno.`;
        else ipotesi = ` Nell'ordinario il netto \xe8 ${netto}. Se limitassi il fatturato a ${fatturatoLimite} per rientrare nel forfettario ti resterebbero ${nettoFor}: <strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.differenzaAssoluta)}</strong> in meno all'anno, quindi fatturare di pi\xf9 ti conviene anche restando nell'ordinario.`;
        $11b417f0dcf3b99c$var$setHtml('confrontoVerdettoTesto', `<strong>Il forfettario non \xe8 utilizzabile con questo fatturato.</strong> ${ammissibilita.motivo}${ipotesi}`);
        setIcona('ph-warning-circle');
        wrapper.classList.add('is-blocked');
    } else if (!accessibile) {
        // La colonna forfettario resta a schermo anche quando il regime e'
        // precluso, quindi va detto cosa vale quel numero: e' l'ipotesi "se
        // potessi usarlo", non una scelta disponibile. Il segno conta: se a
        // vincere e' l'ordinario, dire che il requisito mancante "ti costa"
        // qualcosa sarebbe falso.
        const netto = `<strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.nettoOrdinario)}</strong>`;
        let ipotesi;
        if (migliore === 'pari') ipotesi = ` Restando nell'ordinario il netto \xe8 ${netto}, lo stesso che ti lascerebbe il forfettario: qui non stai perdendo nulla.`;
        else if (migliore === 'forfettario') ipotesi = ` Restando nell'ordinario il netto \xe8 ${netto}: il forfettario, se potessi usarlo, ti lascerebbe <strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.differenzaAssoluta)}</strong> in pi\xf9 all'anno, ${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.differenzaMensile)} al mese.`;
        else ipotesi = ` Restando nell'ordinario il netto \xe8 ${netto}: il forfettario ti lascerebbe <strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.differenzaAssoluta)}</strong> in meno all'anno, quindi il regime agevolato non ti converrebbe comunque.`;
        $11b417f0dcf3b99c$var$setHtml('confrontoVerdettoTesto', `<strong>Il forfettario non \xe8 utilizzabile.</strong> ${ammissibilita.motivo}${ipotesi}`);
        setIcona('ph-warning-circle');
        wrapper.classList.add('is-blocked');
    } else {
        wrapper.classList.remove('is-blocked');
        setIcona('ph-scales');
        if (migliore === 'pari') $11b417f0dcf3b99c$var$setHtml('confrontoVerdettoTesto', "Con questi numeri i due regimi ti lasciano <strong>lo stesso netto</strong>: a decidere sono gli adempimenti, l'IVA e la deducibilit\xe0 dei costi futuri.");
        else {
            const vincitore = migliore === 'forfettario' ? 'il forfettario' : "l'ordinario";
            $11b417f0dcf3b99c$var$setHtml('confrontoVerdettoTesto', `Con questi numeri conviene <strong>${vincitore}</strong>: ` + `<strong>${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.differenzaAssoluta)}</strong> in pi\xf9 all'anno, ` + `${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.differenzaMensile)} al mese.`);
        }
    }
    // --- Intro e nota sulle ipotesi ----------------------------------------
    $11b417f0dcf3b99c$var$setHtml('confrontoIntro', limitato ? `Il tuo fatturato supera la soglia del forfettario: la colonna del regime agevolato \xe8 calcolata su ${fatturatoLimite}, il massimo consentito.` : daOrdinario ? `Stesso fatturato, stessa cassa: ecco quanto ti resterebbe nel regime agevolato.` : `Stesso fatturato e stessa cassa, ma con i costi reali dedotti e l'IRPEF progressiva al posto dell'imposta sostitutiva.`);
    // Il netto forfettario e' quello del regime, senza costi: la nota lo dice
    // e, quando i costi ci sono, quantifica quanto resterebbe sostenendoli,
    // cosi' il confronto con l'ordinario (che li deduce) resta leggibile.
    const costiNota = Math.max(0, esito.costiReali || 0);
    let noteComuni = "Il netto forfettario \xe8 calcolato come prevede il regime, senza sottrarre i costi reali: nell'ordinario invece sono gi\xe0 dedotti.";
    if (costiNota > 0) noteComuni += ` Se anche nel forfettario sostenessi gli stessi costi (${$11b417f0dcf3b99c$export$676a761f30b5139c(costiNota)}), ti resterebbero ${$11b417f0dcf3b99c$export$676a761f30b5139c(esito.nettoForfettario - costiNota)}.`;
    $11b417f0dcf3b99c$var$setHtml('confrontoNota', `${noteComuni} ${opts.notaIpotesi || ''}`);
    // --- CTA ----------------------------------------------------------------
    const cta = document.getElementById('confrontoCta');
    if (cta && opts.ctaHref) {
        cta.href = opts.ctaHref;
        cta.textContent = daOrdinario ? 'Apri il calcolo forfettario completo' : 'Apri il calcolo ordinario completo';
        cta.style.display = '';
    } else if (cta) cta.style.display = 'none';
}

});

parcelRegister("avAP4", function(module, exports) {
module.exports = JSON.parse('{"metadata":{"anno_riferimento":2026,"data_ultimo_aggiornamento":"2026-07-24","fonte":"Circolare INPS n. 8/2026 (Gestione Separata); Circolare INPS n. 14/2026 (Artigiani/Commercianti); Fondazione ENASARCO 2026; siti ufficiali delle casse professionali (Cassa Forense, Inarcassa, ENPAM, ENPACL, CNPADC, CNPR, CIPAG, ENPAP, ENPAV, EPAP, EPPI, ENPAPI), valori 2026"},"gestioni_previdenziali":[{"id":"INPS_GS","label":"INPS Gestione Separata (Freelance)","gruppo":"INPS","tipo":"PERCENTUALE_PURA","aliquota":26.07,"costo_fisso":0,"massimale_reddito":122295,"note_massimale":"Massimale annuo 2026 (art. 2 c. 18 L. 335/1995): oltre 122.295 \u20AC di reddito non si versano ulteriori contributi. Fonte: Circolare INPS n. 8/2026."},{"id":"INPS_ART","label":"INPS Artigiani","gruppo":"INPS","tipo":"MISTO_CON_MINIMALE","aliquota_eccedenza":24,"minimale_reddito":18808,"costo_fisso_annuo":4521.36,"riduzione_forfettario_disponibile":true,"soglia_solidarieta":56224,"massimale_reddito":122295,"massimale_reddito_ante1996":93707,"note_massimale":"Massimale annuo 2026: 122.295 \u20AC senza anzianita\' contributiva al 31/12/1995, 93.707 \u20AC con anzianita\'. Non frazionabile a mese. Fonte: Circolare INPS n. 14/2026."},{"id":"INPS_COM","label":"INPS Commercianti","gruppo":"INPS","tipo":"MISTO_CON_MINIMALE","aliquota_eccedenza":24.48,"minimale_reddito":18808,"costo_fisso_annuo":4611.64,"riduzione_forfettario_disponibile":true,"soglia_solidarieta":56224,"massimale_reddito":122295,"massimale_reddito_ante1996":93707,"note_massimale":"Massimale annuo 2026: 122.295 \u20AC senza anzianita\' contributiva al 31/12/1995, 93.707 \u20AC con anzianita\'. Non frazionabile a mese. Fonte: Circolare INPS n. 14/2026."},{"id":"ENASARCO_MONO","label":"ENASARCO - Agente monomandatario","gruppo":"ENASARCO","tipo":"ENASARCO","aliquota_agente":8.5,"minimale_annuo_agente":513,"massimale_provvigioni":45717,"mandanti_multipli":false,"note":"Quota a carico agente: 8,5%. Il mandante versa anche la sua quota (8,5%). Massimale provvigionale annuo: 45.717\u20AC. Minimale annuo quota agente: 513\u20AC. Fonte: ENASARCO 2026."},{"id":"ENASARCO_PLURI","label":"ENASARCO - Agente plurimandatario","gruppo":"ENASARCO","tipo":"ENASARCO","aliquota_agente":8.5,"minimale_annuo_agente":257.5,"massimale_provvigioni":null,"massimale_provvigioni_per_mandante":30478,"mandanti_multipli":true,"note":"Quota a carico agente: 8,5%. Massimale e minimale si applicano per rapporto di agenzia: 30.478\u20AC di provvigioni e 257,50\u20AC di minimale per ogni mandante. Fonte: ENASARCO 2026."},{"id":"CASSA_FORENSE","label":"Cassa Forense (Avvocati)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":17,"note":"Soggettivo 17% fino a 131.800 \u20AC e 3% oltre; integrativo 4% (in rivalsa al cliente). Minimi 2026: 2.790 \u20AC soggettivo, 355 \u20AC integrativo (dimezzati per under 35 nei primi 6 anni). Maternit\xe0 2026 non ancora deliberata: usato il valore 2025 (57,65 \u20AC). Fonte: Cassa Forense, tabella contributi minimi 2026.","aliquota_soggettivo":17,"minimo_soggettivo":2790,"limite_reddito_soggettivo":131800,"aliquota_soggettivo_oltre":3,"aliquota_integrativo":4,"minimo_integrativo":355,"contributo_maternita":57.65},{"id":"INARCASSA","label":"Inarcassa (Architetti e Ingegneri)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":14.5,"aliquota_soggettivo":14.5,"minimo_soggettivo":2785,"aliquota_integrativo":4,"minimo_integrativo":850,"contributo_maternita":91,"limite_reddito_soggettivo":145550,"note":"Soggettivo 14,5% fino a 145.550 \u20AC; integrativo 4% (in rivalsa al cliente). Minimi 2026: 2.785 \u20AC soggettivo, 850 \u20AC integrativo. Maternit\xe0 2026 fissata in via provvisoria al valore 2025 (91 \u20AC). Fonte: Inarcassa."},{"id":"ENPAM","label":"ENPAM (Medici)","gruppo":"CASSE_PROFESSIONALI","tipo":"ENPAM","aliquota":19.5,"note":"Quota A fissa per fascia d eta (2026: 304,73 \u20AC fino a 30 anni, 591,47 \u20AC da 30 a 35, 1.109,92 \u20AC da 35 a 40, 2.049,83 \u20AC oltre i 40) piu maternita 84,26 \u20AC. Quota B 19,5% sul reddito eccedente la quota gia coperta dalla Quota A (5.446,77 \u20AC sotto i 40 anni, 10.059,28 \u20AC dai 40), 1% oltre 150.000 \u20AC. Fonte: Fondazione ENPAM.","quota_a":{"studenti":152.37,"under30":304.73,"da30a35":591.47,"da35a40":1109.92,"over40":2049.83},"franchigia_quota_b":{"under40":5446.77,"over40":10059.28},"aliquota_quota_b":19.5,"limite_quota_b":150000,"aliquota_quota_b_oltre":1,"contributo_maternita":84.26},{"id":"ENPACL","label":"ENPACL (Consulenti del Lavoro)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":12,"note":"Soggettivo 12% fino a 122.016 \u20AC; integrativo 4% (in rivalsa al cliente). Minimi 2026: 2.620 \u20AC soggettivo (1.310 \u20AC ridotto), 380 \u20AC integrativo. Fonte: ENPACL.","aliquota_soggettivo":12,"minimo_soggettivo":2620,"limite_reddito_soggettivo":122016,"aliquota_integrativo":4,"minimo_integrativo":380,"contributo_maternita":52.98},{"id":"CNPADC","label":"CNPADC (Dottori Commercialisti)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":12,"note":"Soggettivo dal 12% al 100% (qui si usa l aliquota minima del 12%); integrativo 4% (in rivalsa al cliente). Minimi 2026: 3.180 \u20AC soggettivo, 954 \u20AC integrativo. Fonte: CNPADC.","aliquota_soggettivo":12,"minimo_soggettivo":3180,"aliquota_integrativo":4,"minimo_integrativo":954,"contributo_maternita":0},{"id":"CNPR","label":"CNPR (Ragionieri)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":15,"note":"Soggettivo 15% (minimo 3.771,10 \u20AC) pi\xf9 supplementare 0,75% (minimo 636 \u20AC); integrativo 4% (in rivalsa al cliente, minimo 936,06 \u20AC). Maternit\xe0 12 \u20AC. Fonte: CNPR.","aliquota_soggettivo":15,"minimo_soggettivo":3771.1,"aliquota_soggettivo_supplementare":0.75,"minimo_soggettivo_supplementare":636,"aliquota_integrativo":4,"minimo_integrativo":936.06,"contributo_maternita":12},{"id":"CIPAG","label":"CIPAG (Geometri)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":20,"note":"Soggettivo 20% fino a 183.550 \u20AC; integrativo 5% (in rivalsa al cliente). Minimi 2026: 4.240 \u20AC soggettivo, 1.955 \u20AC integrativo, 9 \u20AC maternit\xe0. Fonte: CIPAG, tabella contributi minimi 2026.","aliquota_soggettivo":20,"minimo_soggettivo":4240,"limite_reddito_soggettivo":183550,"aliquota_integrativo":5,"minimo_integrativo":1955,"contributo_maternita":9},{"id":"ENPAP","label":"ENPAP (Psicologi)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":10,"note":"Soggettivo 10% (elevabile fino al 30%), minimo 856 \u20AC; integrativo 2% (in rivalsa al cliente), minimo 66 \u20AC; maternit\xe0 130 \u20AC. Fonte: ENPAP.","aliquota_soggettivo":10,"minimo_soggettivo":856,"aliquota_integrativo":2,"minimo_integrativo":66,"contributo_maternita":130},{"id":"ENPAV","label":"ENPAV (Veterinari)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":18.5,"note":"Soggettivo 18,5% fino a 112.100 \u20AC e 3% oltre (sale di 0,5 punti l anno fino al 22% nel 2033); integrativo 2% (in rivalsa al cliente). Minimi 2026: 3.542,85 \u20AC soggettivo, 574,50 \u20AC integrativo, 100 \u20AC maternit\xe0, 267,50 \u20AC solidariet\xe0. Fonte: ENPAV.","aliquota_soggettivo":18.5,"minimo_soggettivo":3542.85,"limite_reddito_soggettivo":112100,"aliquota_soggettivo_oltre":3,"aliquota_integrativo":2,"minimo_integrativo":574.5,"contributo_maternita":100,"minimo_solidarieta":267.5},{"id":"ENPAB","label":"ENPAB (Biologi)","gruppo":"CASSE_PROFESSIONALI","tipo":"PERCENTUALE_PURA","aliquota":15,"minimi_non_modellati":true,"note":"Soggettivo 15% del reddito netto (elevabile fino al 36%), integrativo 4% del fatturato, maternita 136 \u20AC. I contributi minimi 2026 non sono inclusi nella stima: il sito ENPAB non era raggiungibile alla data di aggiornamento. Fonte: ENPAB, regolamento di disciplina delle funzioni di previdenza."},{"id":"EPAP","label":"EPAP (Geologi, Chimici, Attuari)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":10,"note":"Soggettivo 10% fino a 122.295 \u20AC; integrativo 4% (in rivalsa al cliente); solidariet\xe0 0,2% (minimo 15 \u20AC). Minimi 2026: 739 \u20AC soggettivo, 295 \u20AC integrativo. Maternit\xe0 2026 in attesa di approvazione ministeriale. Fonte: EPAP.","aliquota_soggettivo":10,"minimo_soggettivo":739,"limite_reddito_soggettivo":122295,"aliquota_integrativo":4,"minimo_integrativo":295,"contributo_maternita":0,"aliquota_solidarieta":0.2,"minimo_solidarieta":15},{"id":"EPPI","label":"EPPI (Periti Industriali)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":18,"note":"Soggettivo 18% fino al massimale; integrativo 5% (in rivalsa al cliente). Minimi: 2.359 \u20AC soggettivo, 655 \u20AC integrativo. Maternit\xe0 2026 non ancora deliberata. Il massimale indicato dalla cassa (120.607 \u20AC) coincide con quello INPS 2025: verificare l aggiornamento 2026. Fonte: EPPI.","aliquota_soggettivo":18,"minimo_soggettivo":2359,"limite_reddito_soggettivo":120607,"aliquota_integrativo":5,"minimo_integrativo":655,"contributo_maternita":0},{"id":"ENPAPI","label":"ENPAPI (Infermieri)","gruppo":"CASSE_PROFESSIONALI","tipo":"CASSA_CON_MINIMI","aliquota":16,"note":"Soggettivo 16% (minimo 1.600 \u20AC); integrativo 4% (in rivalsa al cliente, minimo 150 \u20AC). Maternit\xe0 determinata annualmente dal CdA. La pagina ufficiale non riporta l anno: verificare l aggiornamento 2026. Fonte: ENPAPI.","aliquota_soggettivo":16,"minimo_soggettivo":1600,"aliquota_integrativo":4,"minimo_integrativo":150,"contributo_maternita":0}]}');

});


//# sourceMappingURL=piva-ordinaria.9b85864f.js.map
